<template>
  <svg class="svg-colored" :width="`${svgWidth}px`" :height="`${svgHeight}px`" :viewBox="`0 0 ${svgWidth} ${svgHeight}`"
       xmlns="http://www.w3.org/2000/svg">
    <title>{{ title }}</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" v-html="svgCode"></g>
  </svg>
</template>

<script>
function requireIcon(icon) { return require(`raw-loader!./../../assets/markers/${icon}.svgo`) }

const ICONS = {
  dairy:   { width: 14, height: 19, code: requireIcon('dairy') },
  eggs:    { width: 18, height: 23, code: requireIcon('eggs') },
  gluten:  { width: 13, height: 22, code: requireIcon('gluten') },
  nuts:    { width:  9, height: 20, code: requireIcon('nuts') },
  seafood: { width: 22, height: 18, code: requireIcon('seafood') },
  soy:     { width: 20, height: 21, code: requireIcon('soy') },
}

export default {
  props: {
    ingredient: { type: String, required: true },
    title: { type: String },
    color: { type: String, default: 'black' },
    width: { type: Number },
    height: { type: Number },
  },

  data() {
    const icon = ICONS[this.ingredient]
    return {
      svgWidth: this.width || icon.width,
      svgHeight: this.height || icon.height,
      svgCode: icon.code
        .replace('svg__fill', `svg__fill--${this.color}`)
        .replace('svg__stroke', `svg__stroke--${this.color}`),
    }
  },

  methods: {
  },
}
</script>

<style lang="scss">
.svg-colored .svg__fill--primary { fill: $primary }
.svg-colored .svg__stroke--primary { stroke: $primary }
.svg-colored .svg__fill--black { fill: $black }
.svg-colored .svg__stroke--black { stroke: $black }
</style>
